import type { Command } from '../../types/commands'

export const clearCommand: Command = {
  name: 'clear',
  description: 'Clear terminal output',
  aliases: ['cls'],
  category: 'system',
  execute: () => {
    // This will be handled by the Terminal component
    // Returning a special marker
    return [
      {
        type: 'info',
        content: '__CLEAR__',
      },
    ]
  },
}
